import { useMutation } from "@tanstack/react-query";

import { login } from "@/common/services/auth/Auth.service";

import type { LoginFormValues } from "./login.schema";

type LoginFailure = {
  status?: number | null;
};

const getLoginErrorMessageId = (error: unknown): string => {
  const status = (error as LoginFailure)?.status ?? null;

  if (status === 400 || status === 401) {
    return "Login.incorrect-login";
  }

  if (status === 0 || status === null) {
    return "Login.network-error";
  }

  return "common.error";
};

const useLoginMutation = () =>
  useMutation({
    mutationFn: (credentials: LoginFormValues) => login(credentials),
    // the caller maps the HTTP status onto one of three messages
    meta: { silent: true },
  });

export { useLoginMutation, getLoginErrorMessageId };
